import React from "react";
import ToastMessage from "react-native-toast-message";
import { config } from "./configs";
import { sn } from "utils";

function Provider() {
  return (
    <ToastMessage
      autoHide={true}
      config={config}
      topOffset={sn(30, 30, 10, 10)}
      visibilityTime={2000}
      position="top"
    />
  );
}

type IToast = {
  title?: string;
  message?: string;
};
const success = (args: IToast) =>
  ToastMessage.show({
    type: "success",
    text1: args.title,
    text2: args.message,
  });

const error = (args: IToast) =>
  ToastMessage.show({ type: "error", text1: args.title, text2: args.message });

const warning = (args: IToast) =>
  ToastMessage.show({
    type: "warning",
    text1: args.title,
    text2: args.message,
  });

const info = (args: IToast) =>
  ToastMessage.show({ type: "info", text1: args.title, text2: args.message });

export default { Provider, success, error, warning, info };
